

<template>

<div>
    <v-row class="ma-1" style="height: 60px;margin-top:  2% !important;">
        <v-col>
            <v-autocomplete cols="2" @focus="fetchMakes" v-model="make" :rules="[rules.required]" :items="makes" dense chips clearable @change="makeChange" item-color='blue' small-chips label="Make" solo></v-autocomplete>
        </v-col>
        <v-col>
            <v-autocomplete cols="2" v-model="model" :rules="[rules.required]" :items="models" dense chips @change="modelChange" small-chips label="Model" solo></v-autocomplete>
        </v-col>
        <v-col>
            <v-autocomplete cols="2" v-model="year" :rules="[rules.required]" :items="years" dense chips small-chips label="Year" solo></v-autocomplete>
        </v-col>
        <v-col>
            <div class="d-flex">
                <v-btn rounded color="primary" @click="search">
                    Search
                </v-btn>
                <v-btn rounded color="info" @click="add" style="margin-left:6%">
                    New Vehicle
                </v-btn>
            </div>
        </v-col>
    </v-row>

    <v-divider></v-divider>

    <div v-show="vehicle != null" style="width:100%;height:100%;margin-top:2%">
        <ViewVehicle :item="vehicle"></ViewVehicle>
    </div>

    <div style="width:100%;height:100%;margin-top:1%">
        <router-view></router-view>
    </div>

</div>

</template>

<script>

import ViewVehicle from './ViewVehicle.vue'

export default {
    components: {
        ViewVehicle
    },
    created() {
        //this.fetchMakes();
    },
    data: () => ({
        makes: [],
        make: '',
        models: [],
        model: '',
        years: [],
        year: '',
        vehicle: null,
         rules: {
            required: value => !!value || 'Required.',
            
            }
    }),
    methods: {
        makeChange() {
                this.model = '';
                this.year = '';
                if (this.make != null) {
                    this.$api.getModels(this.make).then((response) => {
                        if (response.status == 200) {
                            this.models = response.data;
                        }
                    })
                }
            },
            modelChange() {
                this.year = '';
                if (this.make != null && this.model != null) {
                    this.$api.getYears(this.make, this.model).then((response) => {
                        if (response.status == 200) {
                            this.years = response.data;
                        }
                    })
                }
            },
            search() {
                if (!this.make == '' && !this.model == '' && !this.year == '') {
                   // this.$toasted.error('Selection incomplete').goAway(1200)
                   // return;
                
                this.$overlay.show(this);

                this.$api.searchVehicle(this.make, this.model, this.year).then((response) => {
                    if (response.status == 200) {
                        this.vehicle = response.data;
                    }
                    this.$overlay.hide();
                }).then(error => {
                    this.$overlay.hide();
                })
                }else{
                     this.$toasted.error('Selection incomplete').goAway(1200)
                    return;
                }
            },
            add() {
                this.make = '';
                this.model = '';
                this.year = '';
                this.vehicle = null;
                this.$router.push('/inventory/vehicles/new');
            },
            fetchMakes() {
                this.$api.getMakes().then((response) => {
                    if (response.status == 200)
                        this.makes = response.data;
                })
            },
            deleteVeh() {
                this.vehicle = null;
            }

    }
}

</script>
